import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NxAccordionModule } from '@aposin/ng-aquila/accordion';
import { NxGridModule } from '@aposin/ng-aquila/grid';
import { NxDataDisplayModule } from '@aposin/ng-aquila/data-display';
import { NxCopytextModule } from '@aposin/ng-aquila/copytext';
import { NxButtonModule } from '@aposin/ng-aquila/button';
import { NxIconModule } from '@aposin/ng-aquila/icon';
import { NxDropdownModule } from '@aposin/ng-aquila/dropdown';
import { NxInputModule } from '@aposin/ng-aquila/input';
import { NxFormfieldModule } from '@aposin/ng-aquila/formfield';
import { NxHeadlineModule } from '@aposin/ng-aquila/headline';
import { NxTableModule } from '@aposin/ng-aquila/table';
import { NxListModule } from '@aposin/ng-aquila/list';
import { NxSwipebarModule } from '@aposin/ng-aquila/swipebar';
import { NxCardModule } from '@aposin/ng-aquila/card';
import { NxCheckboxModule } from '@aposin/ng-aquila/checkbox';
import { TextFieldModule } from '@angular/cdk/text-field';
import { NxModalModule } from '@aposin/ng-aquila/modal';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { NxDatefieldModule } from '@aposin/ng-aquila/datefield';
import { NxMomentDateModule } from '@aposin/ng-aquila/moment-date-adapter';
import { NxRadioModule } from '@aposin/ng-aquila/radio-button';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Store, Select } from '@ngxs/store';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import {
  DOWNLOAD_PDF,
  GENERATE_ENDORSEMENT,
  GENERATE_ENDORSEMENT_QUOTATION,
  GET_CHECKLIST_LOV,
  RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ,
  SET_CURRENT_STEP,
  STORE_ISSUANCE_SUMMARY,
  ENQUIRE_ENDT_NARRATION,
  GET_DOCUMENT_LOV,
  CALCULATE_PREMIUM_SUMMARY,
  STORE_ROAD_TAX_PAYABLE,
  ENDT_CALCULATE_PREMIUM_SUMMARY,
  STORE_PAYMENT_INFO,
  ENDT_SAVE_PAYMENT,
  UPDATE_ENDORSEMENT_STEP2,
  SEARCH_ORIXCompanyInfo,
  SET_ENDORSEMENT_GENERATED
} from "@store/sat-motor/sat-motor.action";
import { SharedModule } from '@shared/shared.module';
import { PaymentDetailsComponent } from '@shared/components/payment-details/payment-details.component';
import { PaymentInformationComponent } from '@shared/components/payment-information/payment-information.component';
import { RoadTaxPayableComponent } from "@shared/components/road-tax-payable/road-tax-payable.component";
import { UpsellProductComponent } from '@shared/components/upsell-product/upsell-product.component';
import { UserResponse } from "@interfaces/user";
import { CoverageSummaryComponent } from '@shared/components/coverages/coverage-summary/coverage-summary.component';
import { OkMessageComponent } from '@shared/components/modal/ok-message/ok-message.component';
import moment from 'moment';
import { SatMotorState } from '@store/sat-motor/sat-motor.state';
import { ScrollToError } from '@shared/classes/scroll-to-error';
import { EndorsementNarrationComponent } from "@shared/components/endorsement-narration/endorsement-narration.component";
import { PaymentComponent } from "@shared/components/payment/payment.component";
import { ChecklistComponent } from '@shared/components/checklist/checklist.component';
import { UploadDocumentComponent } from '@shared/components/upload-document/upload-document.component';
import { RemoveCommaPipe } from '@shared/pipes/remove-comma/remove-comma.pipe';
import { ErrorModalComponent } from '@shared/components/modal/error-modal/error-modal.component';
import { RESET_ERROR_MESSAGE, SET_ERROR_FLAG, SET_ERROR_MESSAGE } from '@store/exception/error.action';
import { ErrorState, ErrorModel } from '@store/exception/error.state';
import { SummaryPopupComponent } from 'src/app/popup/summary-popup/summary-popup.component';

@Component({
  selector: 'app-endorsement-summary',
  standalone: true,
  imports: [
    NxAccordionModule,
    NxGridModule,
    NxDataDisplayModule,
    NxCopytextModule,
    NxButtonModule,
    NxIconModule,
    NxDropdownModule,
    NxInputModule,
    NxFormfieldModule,
    NxHeadlineModule,
    NxTableModule,
    NxListModule,
    NxSwipebarModule,
    NxCardModule,
    NxCheckboxModule,
    TextFieldModule,
    NxModalModule,
    NxDatefieldModule,
    NxMomentDateModule,
    NxRadioModule,
    SharedModule,
    PaymentDetailsComponent,
    PaymentInformationComponent,
    RoadTaxPayableComponent,
    UpsellProductComponent,
    CoverageSummaryComponent,
    OkMessageComponent,
    EndorsementNarrationComponent,
    PaymentComponent,
    ChecklistComponent,
  ],
  templateUrl: './endorsement-summary.component.html',
  styleUrl: './endorsement-summary.component.scss'
})
export class EndorsementSummaryComponent implements OnInit, AfterViewInit {

  @ViewChild('paymentSectionStart') paymentSectionStart!: ElementRef;

  @Select(ErrorState.error) error$: Observable<any>;
  componentDialogRef?: NxModalRef<SummaryPopupComponent>;
  isEndorsement: boolean = true;
  progressType: any;
  userInfo: any;
  agentData: any;
  issuanceInfo: any = {};
  clientClaimHistory: any;
  vehicleClaimHistory: any;
  premiumInfo: any;
  coverageInfo: any;
  cpData: any;
  lov: any;
  prevPolicyData: any;
  endorsementStep3Details: any;

  showAgentInfo: boolean = false;
  showIssuanceInfo: boolean = false;
  showCustomerPartner: boolean = false;
  showReferralDetails: boolean = false;
  showCoverage: boolean = false;
  showHistoricalClaim: boolean = false;
  showPremiumInformation: boolean = false;
  showPayment: boolean = false;
  showPaymentInformation: boolean = false;
  showPaymentDetails: boolean = false;
  showChecklist: boolean = false;
  showEndorsementNarration: boolean = false;
  showRoadTaxPayable: boolean = false;
  showCheckList: boolean = false;
  blocked: boolean = false;

  endtPolicy: any;
  endtHtgePol: any;
  endtType: any;
  isDataLoaded: boolean = false;

  dialogRef?: NxModalRef<any>;
  okMessageModal?: NxModalRef<OkMessageComponent>;

  endtSummaryForm: FormGroup;
  checklistLov: any;
  endtNarration: any;

  numberFmt: any;

  payment: any;
  roadTaxPayable: any;
  paymentList: any = [];
  paymentInformation: any;
  isUpdatePayment: boolean = false;
  opportunityId: any;
  isCreatedByCcUser: boolean = false;

  @Select(SatMotorState.premiumCalculationSummary) premiumCalculationSummary$: Observable<SatMotorState>;
  @Select(SatMotorState.endorsementUpdatedData) endorsementUpdatedData$: Observable<SatMotorState>;
  
  constructor(
    private dialogService: NxDialogService,
    public store: Store,
    private router: Router,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.numberFmt = new RemoveCommaPipe();
  }

  ngOnInit() {
    window.scroll({ top: 0, left: 0, behavior: 'instant' });

    const errorCode = this.store.selectSnapshot<any>((state) => state.ErrorState?.detail?.code);
    if (errorCode) {
      this.blocked = errorCode !== 200;
    }

    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.lov = this.store.selectSnapshot<any>((state) => state.SatMotorState.lov);
    this.store.dispatch(new SET_CURRENT_STEP(3));
    this.endtSummaryForm = this.fb.group({
      checklistForm: new FormGroup({}),
    });
    this.isUpdatePayment = this.store.selectSnapshot<any>(state => state.SatMotorState.isUpdatePayment);
    this.prevPolicyData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtVehicleData);
    this.endorsementStep3Details = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step3);
    this.opportunityId = this.store.selectSnapshot<any>((state) => state.SatMotorState.opportunityId);
    this.isCreatedByCcUser = this.store.selectSnapshot<boolean>((state) => state.SatMotorState?.isCreatedByCcUser);


    this.setProgressType();
    this.populateEndorsementData();
    this.isDataLoaded = true;
    this.showComponents();
    this.getDocumentListLov();

    this.endorsementUpdatedData$.subscribe((state) => {
      this.endtPolicy = state || {};
      if (this.endtPolicy) {
        //this.setPremiumInfo(this.endtPolicy.riskList[0].coverList[0], this.endtPolicy);
        //this.getEndorsementNarration();
      }
    });

    this.error$.subscribe((err) => {
      console.log(err);
      if (err?.code)
        this.blocked = (err?.code !== 200);
    });

    if(!this.blocked && this.lov?.endtGenCheckEnabled){
      const isEndorsementGenerated = this.store.selectSnapshot<boolean>((state) => state.SatMotorState.isEndorsementGenerated);
      if(isEndorsementGenerated) this.blocked = true;
    }
  }

  ngAfterViewInit() {
    if (this.isUpdatePayment) {
      setTimeout(() => {
        this.paymentSectionStart.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }

  showComponents() { 
    [
      'showAgentInfo', 'showIssuanceInfo', 'showCustomerPartner', 
      'showCoverage', 'showHistoricalClaim', 'showPremiumInformation', 
      'showChecklist', 'showEndorsementNarration'
    ].forEach(component => this[component] = true); 

    const basicPremium = this.endtPolicy.riskList[0]?.coverList[0]?.basicPremium;
    if (this.userInfo.callCenter && this.premiumInfo.premiumDueRounded > 0) { // add the additional premium checking
      this.showPaymentDetails = true;
      this.showPaymentInformation = true;
      this.showPayment = true;
      if (this.endtType === "XP") {
        this.showRoadTaxPayable = true;
      }
    }

    this.isCheckListVisible(this.endtType);
  }

  isCheckListVisible(endtType: any) {
    let hideEndtTypes = ['COE', 'XP', 'EC175', 'EC176'];
    this.showCheckList = !hideEndtTypes.includes(endtType);
  }

  getDocumentListLov() {
    this.store.dispatch(new GET_DOCUMENT_LOV({
      lob: "MT",
      userId: this.userInfo.userId,
      productCode: this.endtPolicy.productCode,
      productType: "",
      type: 'SATMTCNDOCTYPE'
    }));
  }

  setProgressType() {
    this.progressType = 'endorsement';
  }

  populateEndorsementData() {
    if(!this.endtPolicy)
      this.endtPolicy = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);

    console.log("populateEndorsementData this.endtPolicy endtUpdatedData:", this.endtPolicy);
    
    this.endtHtgePol = this.store.selectSnapshot<any>(state => state.SatMotorState?.endtHtgePol ?? state.SatMotorState?.endorsement?.step1?.endtPreviousVehicleData ??  null);
    this.endtType = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.issuance?.issuance?.endorsementType);

    const { mkagAgent, riskList = [{}], clientPartner: cpData, ...cngeNote } = this.endtPolicy;
    const [risk] = riskList;
    const [coverList] = riskList[0]?.coverList || [];

    this.setAgentInfo(mkagAgent, cngeNote);
    this.clientInfo(cpData);
    this.setIssuanceInfo(cngeNote, risk);
    this.setCoverageInfo(this.endtPolicy, cpData);
    this.setPremiumInfo(coverList, cngeNote);
    this.setClaimHistory(this.endtHtgePol);

    let endtData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step2?.endorsementDetails);
    this.getChecklistLov();
    this.getEndorsementNarration();

    if(this.userInfo.callCenter) {
      this.getPaymentData(this.endtPolicy);
    }

    this.getORIXInfo();
  }

  setAgentInfo(mkagAgent: any, cngeNote: any) {
    this.agentData = {
      agentCode: mkagAgent.agentCode,
      name: mkagAgent.name,
      issuedBy: this.userInfo.userId,
      issuedDate: new Date().toISOString().substring(0, 10),
      branchCode: mkagAgent?.branchCode
    };
  }

  clientInfo(cpData: any) {
    let eInvoiceCustomerPartner = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step2?.endorsementDetails?.eInvoiceCustomerPartner);
    // console.log("clientInfo eInvoiceCustomerPartner:", eInvoiceCustomerPartner);
    
    if (eInvoiceCustomerPartner && this.endtType === 'EC175') {
      this.cpData = eInvoiceCustomerPartner;
    } else {
      this.cpData = cpData;
    }

    // this.cpData = cpData;
    // console.log("clientInfo cpData:", cpData);
  }

  setIssuanceInfo(cngeNote: any, risk: any) {
    let issuanceData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step1.issuance);
    // console.log("setIssuanceInfo issuanceData:", issuanceData);

    const vehicleNo = (this.endtType === 'ENDT12') ? risk.vehicleNo : cngeNote.vehicleNo ?? risk.vehicleNo;

    this.issuanceInfo = {
      issuance: {
        endorsementType: this.endtType,
        policyNo: issuanceData.issuance.policyNo,
        endtReferenceNo: this.endtPolicy.endtReferenceNo, //will be available after sendToJPJ
        endtNo: this.endtPolicy.endtNo, //will be available after saveQuotation
        endtEffectiveDate: issuanceData.issuance.endtEffectiveDate,
        endtExpiryDate: issuanceData.issuance.endtExpiryDate,
        productCode: cngeNote.productCode,
        vehicleNo: vehicleNo,
        cnoteType: cngeNote.cnoteType,
        prevPolicyNo: cngeNote.previousPolicyNo,
        effectiveDate: cngeNote.effectiveDate,
        expiryDate: cngeNote.expiryDate,
        equotationNo: cngeNote.proposalNo,
        equotationCreatedDate: cngeNote.createDate,
        eCoverNoteNo: cngeNote.cnoteNo,
        jpjStatus: risk.jpjStatus,
        jpjMessage: cngeNote.jpjMessage,
      },
      pdpa: {
        consentDetails: {
          einvoiceConsentInd: issuanceData?.pdpa?.consentDetails?.einvoiceConsentInd,
        },
      },
    };
  }

  setCoverageInfo(policy: any, cpData) {
    let risk = policy.riskList[0];
    let coverList = risk.coverList[0];
    let ehailingDriverDetails = this.getDriverList(risk.cngeRiskDrvrDtoList, false, cpData);
    let thailandDate = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step3?.coverage?.extracover?.thailandDate);
    if(this.endorsementStep3Details?.coverage?.extracover?.ehailingDriverDetails?.rows){
      ehailingDriverDetails = this.endorsementStep3Details?.coverage?.extracover?.ehailingDriverDetails?.rows;
    }

    const prevNcdVeh = (this.endtType === 'ENDT12') ? risk.vehicleNo 
      : risk.prevNcdVeh ? risk.prevNcdVeh.toUpperCase() : coverList.prevNcdVeh

    this.coverageInfo = {
      vehicleDetails: {
        ...risk,
        region: policy.region
      },
      coverageDetails: {
        ...coverList,
        prevNcdInsurer: risk.prevNcdInsurer,
        prevNcdVeh: prevNcdVeh,
        prevNcdEffDate: risk.prevNcdEffDate,
        avInd: risk.avInd
      },
      driverNameDetails: this.getDriverList(risk.cngeRiskDrvrDtoList, true, cpData),
      ehailingDriverDetails:  ehailingDriverDetails,
      extraCoverPackageSummary: this.getExtraCoverage(policy, cpData),
      productCode: policy.productCode,
      thailandDate: thailandDate
    };
  }

  setPremiumInfo(premiumInfo: any, cngeNote: any) {
    this.premiumInfo = {
      ...premiumInfo,
      stamp: cngeNote.stamp,
      premiumDue: cngeNote.premiumDue,
      premiumDueRounded: cngeNote.premiumDueRounded
    };

    if(this.opportunityId || this.isCreatedByCcUser) {
      this.premiumInfo.premiumDueRounded = cngeNote.cCentrixPremiumDueRounded;
    }
  }

  setClaimHistory(htgePol: any) {
    this.clientClaimHistory = htgePol?.clientClaimCount ?? '0';
    this.vehicleClaimHistory = htgePol?.vehClaimCount ?? '0';
  }

  getDriverList(cngeRiskDrvrDtoList, isNormalDriver, cpData) {
    let filteredList = cngeRiskDrvrDtoList?.filter(({ cngeRiskDrvrPkDto: { driverType } }) =>
      isNormalDriver ? driverType === 'NORM' : driverType === 'EHAIL'
    );

    if (filteredList && filteredList.length > 0) {
      if (!filteredList[0].driverId) {
        filteredList = filteredList.map(driver => ({
          ...driver,
          driverId: driver.driverId || cpData.idValue1 || cpData.idValue2
        }));
      }
    }

    return filteredList?.map(({ cngeRiskDrvrPkDto: { driverName }, driverId, driverAge }) => ({
      driverName,
      driverId,
      driverAge,
    })) || null;
  }

  setupEHailing(ehailingDriverList): any {
    let cngeRiskDrvrDtoListEhailing = ehailingDriverList.map((driver) => {
      let driverName;
      if (driver.driverName) {
        driverName = driver.driverName;
      } else if (driver?.cngeRiskDrvrPkDto?.driverName) {
        driverName = driver.cngeRiskDrvrPkDto.driverName;
      }

      let cngeRiskDrvrPkDto = {
        cngeRiskDrvrPkDto: {
          driverName: driverName ? driverName : "",
          driverType: "EHAIL",
        },
        driverId: driver.driverId,
        driverAge: 0, // Assuming `0` is the default driver age for ehailing drivers
        driverSeq: driver.driverSeq,
      };

      return cngeRiskDrvrPkDto;
    });

    return cngeRiskDrvrDtoListEhailing; // Ensure the processed list is returned
  }

  getExtraCoverage(cngeNoteDto: any, cpData: any) {
    const coverDto = cngeNoteDto?.riskList?.[0]?.coverList?.[0]?.coverDto;
    const coverList = cngeNoteDto?.riskList?.[0]?.coverList[0];
    const riskList = cngeNoteDto?.riskList?.[0];

    const validCnoteTypes = ['ENDT10', 'ENDT12', 'ENDT18', 'ENDT75', 'ENDT16', 'EC175', 'EC176'];
    const previousSubCoverList =  this.endtHtgePol.riskList?.[0]?.coverList?.[0]?.subCoverList?.filter(o1 => o1.subCoverPrem > 0);
    const previousSubCoverCodes = previousSubCoverList ? new Set(previousSubCoverList.map(o => o.subCoverCode)) : new Set();
    const allowedVehicleUses = ['12','12-01', '12-02-03', '12-02-04', '12-03', '13']; 
    const allowedVehicleUsesBusiness = ['11','11-01', '12-02-01', '12-02-02']; 

    const packageCode = coverDto?.subCovPackageList?.[0]?.packageCode || null;
    const validPackageCode = packageCode !== undefined ? packageCode : null;

    if (validCnoteTypes.includes(this.endtType)) { 
          //no calculate premium
      if (!coverList || !coverList.subCoverList) {
        return {
          subCovPackageDesc: null,
          rahmahPackageList: [],
          topExtraCoverList: [],
          selectedExtraCoverList: [],
        };
      }

      const extraCoverPackage = coverList.subCoverList.map(cv => ({
        ...cv,
        description: cv.subCoverCodeDescription,
        selected: cv.selectedInd,
        enabled: cv.enableInd ?? false,
      }));

      let rahmahPackageList = extraCoverPackage.filter(o1 => o1.subCovPackage && !o1.subCoverPrem);
      let topExtraCoverList = extraCoverPackage
        .filter(o1 => o1.selectedInd && !o1.subCoverPrem && !previousSubCoverCodes.has(o1.subCoverCode))
        .filter(o1 => !rahmahPackageList.some(rp => rp.subCoverCode === o1.subCoverCode))
        .filter(o1 => (o1.subCoverCode === '57' && !allowedVehicleUses.includes(riskList.vehicleUse) && (cpData.idType1 !== 'BR_NO' && cpData.idType1 !== 'NEW_BR_NO')) || 
        (o1.subCoverCode === '57' && !allowedVehicleUsesBusiness.includes(riskList.vehicleUse) && (cpData.idType1 === 'BR_NO' || cpData.idType1 === 'NEW_BR_NO')) || 
        (o1.subCoverCode !== 'A221' && o1.subCoverCode !== '57'));

      let selectedExtraCoverList = extraCoverPackage.filter(o1 => o1.selected && (validPackageCode === null || o1.subCovPackage !== validPackageCode));
      selectedExtraCoverList = selectedExtraCoverList.filter(o1 => !topExtraCoverList.some(o2 => o2.subCoverCode === o1.subCoverCode));

      return {
        subCovPackageDesc: coverList.subCovPackageDesc ?? null,
        costInd: coverList.costInd,
        rahmahPackageList: rahmahPackageList,
        topExtraCoverList: topExtraCoverList,
        selectedExtraCoverList: selectedExtraCoverList
      };
    }else{
      //have calculate premium
      if (!coverList || !coverDto.subCovList) {
        return {
          subCovPackageDesc: null,
          rahmahPackageList: [],
          topExtraCoverList: [],
          selectedExtraCoverList: [],
        };
      }

      let subCovList = coverDto.subCovList.map((obj) => {
       
        return {
          ...obj,
          subcoverNarrCode: obj.templateCode,
          subcoverNarrDesc: obj.sumInsuredDisplay,
        };
      });

      let rahmahPackageList = subCovList.filter(o1 => o1.subCovPackage && o1.subCoverPrem == 0);

      let topExtraCoverList = subCovList
        .filter(o1 => o1.selected && o1.subCoverPrem == 0 && !previousSubCoverCodes.has(o1.subCoverCode))
        .filter(o1 => !rahmahPackageList.some(rp => rp.subCoverCode === o1.subCoverCode))
        .filter(o1 => (o1.subCoverCode === '57' && (cpData.idType1 !== 'BR_NO' && cpData.idType1 !== 'NEW_BR_NO') && !allowedVehicleUses.includes(riskList.vehicleUse)) ||
        (o1.subCoverCode === '57' && (cpData.idType1 === 'BR_NO' || cpData.idType1 === 'NEW_BR_NO') && !allowedVehicleUsesBusiness.includes(riskList.vehicleUse)) ||
        (o1.subCoverCode !== 'A221' && o1.subCoverCode !== '57'));

      let selectedExtraCoverList = subCovList.filter(o1 => o1.selected  && (validPackageCode === null || o1.subCovPackage !== validPackageCode));
      selectedExtraCoverList = selectedExtraCoverList.filter(o1 => !topExtraCoverList.some(o2 => o2.subCoverCode === o1.subCoverCode));

      return {
        subCovPackageDesc: coverList.subCovPackageDesc ?? null,
        costInd: coverList.costInd,
        rahmahPackageList: rahmahPackageList,
        topExtraCoverList: topExtraCoverList,
        selectedExtraCoverList: selectedExtraCoverList
      };
    }
  }

  navigateBackTo(route: string) {
    this.saveCheckList();
    const payload = {
      isReset: false,
      cngeNote: this.endtPolicy
    };
    this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2(payload)).subscribe((state) => {
      this.router.navigate([route], {
        queryParamsHandling: 'preserve',
      });
    });
  }

  goToIssueDeclaration() {
    this.navigateBackTo("endorsement/declaration-issuance-info");
  }

  goToCoverageScreen() {
    this.navigateBackTo("endorsement/endorsement-details");
  }

  goBack() {
    this.navigateBackTo("endorsement/endorsement-details");
  }

  generate() {
    const isEinvoice10kIndEnabled = this.store.selectSnapshot(SatMotorState.isEinvoice10kIndEnabled);
    if (isEinvoice10kIndEnabled && !this.einvoiceConsentInd() && this.isGrossPremiumMoreThan10k()){
      this.openPopup("einvoiceConsentChange", "generateQuotation");
      return;
    }
    let policy = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1.policyData);
    let issuanceData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step1.issuance);
    this.endtPolicy = {
      ...this.endtPolicy,
      riskList: [{ ...this.endtPolicy.riskList[0] }],
      endtEffectiveDate: issuanceData?.issuance?.endtEffectiveDate ? new Date(issuanceData.issuance.endtEffectiveDate).toISOString().split('T')[0] : null,
      endtExpiryDate: issuanceData?.issuance?.endtExpiryDate ? new Date(issuanceData.issuance.endtExpiryDate).toISOString().split('T')[0] : null,
      einvoiceConsentInd: this.einvoiceConsentInd(),
      issueBy: this.userInfo.userId,
      endtNarration: this.endtNarration
    };

    if (!this.endtPolicy.riskList[0]?.vehicleModel ||
      this.endtPolicy.riskList[0]?.vehicleModel === '') {

      if (this.endtType !== 'ENDT34') {
        this.endtPolicy.riskList[0].vehicleModel = policy?.cngeNoteDto?.riskList[0]?.vehicleModel || '';
      } else {
        this.endtPolicy.riskList[0].vehicleModel = this.endtPolicy.riskList[0].vehModelNvic || '';
      }
    }

    if(this.endtSummaryForm.get("checklistForm")) {
      this.endtPolicy.declareList = this.endtSummaryForm.get("checklistForm")?.get("rows")?.value;
      this.endtPolicy.chklistRemarks = this.endtSummaryForm.get("checklistForm")?.get("remarks")?.value;
    }

    let resetPayload = {
      isEndorsement: true
    };

    let payload = {
      policy: this.endtPolicy,
      endtType: this.endtType,
      userId: this.userInfo.userId
    }

    //this.store.dispatch(new RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ(resetPayload));
    this.store.dispatch(new GENERATE_ENDORSEMENT_QUOTATION(payload))
    .pipe(
      catchError(e => {
        this.store.dispatch(new SET_ERROR_MESSAGE(e));
        this.dialogService.open(ErrorModalComponent, {
          disableClose: true,
          width: "400px",  data: { e: e },
        });
        return throwError(e);
      })
    )
    .subscribe(() => {
      let response = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.generateQuotation ?? null);

      if (response && response.data && response.success) {
        this.router.navigate(['endorsement/complete'], {
           queryParamsHandling: 'preserve',
        });
      } else {
        this.showResponseError(response);
      }
    });
  }

  saveCheckList() {
    if (this.endtSummaryForm.get("checklistForm")) {
      this.endtPolicy = {
        ...this.endtPolicy,
        declareList: this.endtSummaryForm.get("checklistForm")?.get("rows")?.value ?? null,
        chklistRemarks: this.endtSummaryForm.get("checklistForm")?.get("remarks")?.value ?? null
      }
    }
  }

  sendToJPJ() {

    if (!this.endtNarration){
      this.openPopup("endtNarration", "endtNarration");
      return;
    }

    const isEinvoice10kIndEnabled = this.store.selectSnapshot(SatMotorState.isEinvoice10kIndEnabled);
    if (isEinvoice10kIndEnabled && !this.einvoiceConsentInd() && this.isGrossPremiumMoreThan10k()){
      this.openPopup("einvoiceConsentChange", "sendToJPJ");
      return;
    }
    let policy = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1.policyData);
    let issuanceData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step1.issuance);

    const oldVehicleNo = this.endtPolicy.vehicleNo;
    const riskData = this.endtPolicy.riskList[0];
    const updatedRisk = { ...riskData };

    if (this.endtType === 'ENDT12') {
      this.endtPolicy = {
        ...this.endtPolicy,
        vehicleNo: riskData.vehicleNo
      };

      if (updatedRisk.prevNcdVeh) {
        updatedRisk.prevNcdVeh = riskData.vehicleNo;
      }

      if (updatedRisk.riskDescription?.includes(oldVehicleNo)) {
        updatedRisk.riskDescription = updatedRisk.riskDescription.replace(oldVehicleNo, riskData.vehicleNo);
      }
    }

    this.endtPolicy = {
      ...this.endtPolicy,
      riskList: [updatedRisk],
      endtEffectiveDate: issuanceData?.issuance?.endtEffectiveDate ? new Date(issuanceData.issuance.endtEffectiveDate).toISOString().split('T')[0] : null,
      endtExpiryDate: issuanceData?.issuance?.endtExpiryDate ? new Date(issuanceData.issuance.endtExpiryDate).toISOString().split('T')[0] : null,
      einvoiceConsentInd: this.einvoiceConsentInd(),
      issueBy: this.userInfo.userId,
      nettPremium: this.endtPolicy.riskList[0].coverList[0].nettPremium,
      endtNarration: this.endtNarration,
      claimCnt: this.endtHtgePol?.clientClaimCount,
      vehClaimCount: this.endtHtgePol?.vehClaimCount,
    };

    if (!this.endtPolicy.riskList[0]?.vehicleModel ||
      this.endtPolicy.riskList[0]?.vehicleModel === '') {

      if (this.endtType !== 'ENDT34') {
        this.endtPolicy.riskList[0].vehicleModel = policy?.cngeNoteDto?.riskList[0]?.vehicleModel || '';
      } else {
        this.endtPolicy.riskList[0].vehicleModel = this.endtPolicy.riskList[0].vehModelNvic || '';
      }
    }

    if(this.endtSummaryForm.get("checklistForm")) {
      this.endtPolicy.declareList = this.endtSummaryForm.get("checklistForm")?.get("rows")?.value;
      this.endtPolicy.chklistRemarks = this.endtSummaryForm.get("checklistForm")?.get("remarks")?.value;
    }

    let resetPayload = {
      isEndorsement: true
    };

    let payload = {
      policy: this.endtPolicy,
      endtType: this.endtType,
      userId: this.userInfo.userId
    }

    if (this.endtType === 'EC175') {
      let endtNarration = this.endtNarration.replaceAll(
        '<P>"User to input the narration"</P>', 
        this.endtSummaryForm.get("narrationForm").getRawValue().txtNarration);
      payload = { 
        ...payload, 
        policy: {
          ...payload.policy,
          endtNarration: endtNarration 
        }
      }
    }

    //this.store.dispatch(new RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ(resetPayload));
    this.store.dispatch(new SET_ERROR_FLAG({ code: 999 })).subscribe(() => { this.blocked = true; });
    this.store.dispatch(new GENERATE_ENDORSEMENT(payload))
    .pipe(
      catchError(e => {
        this.store.dispatch(new SET_ERROR_MESSAGE(e));
        this.dialogService.open(ErrorModalComponent, {
          disableClose: true,
          width: "400px",  data: { e: e },
        });
        return throwError(e);
      })
    )
    .subscribe(() => {
     this.store.dispatch(new RESET_ERROR_MESSAGE()).subscribe(() => { this.blocked = false; });
      let response = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.sendToJPJ ?? null);

      if (response && response.data && response.success) {
        if(this.lov?.endtGenCheckEnabled){
          this.store.dispatch (new SET_ENDORSEMENT_GENERATED());
        }
        this.router.navigate(['endorsement/complete'], {
          queryParamsHandling: 'preserve',
        });
      } else {
        this.showResponseError(response);
      }
    });
  }

  showResponseError(response: any) {
    console.log('showResponseError response:' + response);
    let message = (response.message && response.message != '') ? response.message : (response.errorCode && response.errorCode != '') ? response.errorCode : null;

    if (message) {
      this.okMessageModal = this.dialogService.open(OkMessageComponent, {
        disableClose: true,
        width: '400px',
        data: {
          message: message
        }
      });
    }
  }

  uploadDocument() {
    let payload = {
      policy: this.endtPolicy,
      endtType: this.endtType,
      userId: this.userInfo.userId
    }

    if (this.endtType === 'EC175') {
      let endtNarration = this.endtNarration.replaceAll(
        '<P>"User to input the narration"</P>', 
        this.endtSummaryForm.get("narrationForm").getRawValue().txtNarration);
      payload = { 
        ...payload, 
        policy: {
          ...payload.policy,
          endtNarration: endtNarration 
        }
      }
    }

    let endtDraftResponse = this.store.selectSnapshot<any>((state) => state.SatMotorState.draftDetails ?? null);

    let dialogConfig = {
      showCloseIcon: false,
      disableClose: true,
      width: "80%",
      maxWidth: "80vw",
      maxHeight: "95vh",
      data: {
        contractId: endtDraftResponse?.contractId ?? this.endtPolicy.contractId,
        isEndorsement: true,
        endtPayload: payload
      }
    };

    this.dialogRef = this.dialogService.open(UploadDocumentComponent, dialogConfig);
  }

  getJPJButtonName() {
    if (this.endtType === 'COE' || this.endtType === 'XP') {
      return 'SEND TO JPJ';
    } else {
      return 'GENERATE ENDORSEMENT';
    }
  }

  updateVehicleDetails(updatedData: any) {
    this.coverageInfo = {
      ...this.coverageInfo,
      vehicleDetails: updatedData
    };
  }

  showGenerateBtn() {
    if(this.isUpdatePayment) {
      return false;
    }
    
    if (this.userInfo.callCenter && this.userInfo.callCentreType == "T" && this.endtType == 'XP') {
      return true;
    } else {
      return false;
    }
  }

  showJpjButton() {
    if(this.isUpdatePayment) {
      return false;
    }

    if(this.userInfo.callCenter && this.userInfo.callCentreType == "T") {
      return false;
    }else {
      return true;
    }
  }

  disableGenerateButton() {
    if (this.blocked)
      return true;
    return false;
  }
  
  disableJpjButton() {
    if (this.blocked)
      return true;
    return false;
  }
  
  disableUploadButton() {
    if (this.blocked)
      return true;
    return false;
  }

  getEndorsementNarration() {
    const subCoverList = this.prevPolicyData?.riskList?.[0]?.coverList?.[0]?.subCoverList || [];
    let htgeSubCoverList = this.endtHtgePol?.riskList?.[0]?.coverList?.[0]?.subCoverList || [];
    let newSubCoverList = this.endtPolicy.riskList?.[0]?.coverList?.[0]?.subCoverList || [];
    let ehailingDriverList = this.endorsementStep3Details?.coverage?.extracover?.ehailingDriverDetails?.rows || [];
    let cngeRiskDrvrDtoList = this.endtPolicy.riskList?.[0]?.cngeRiskDrvrDtoList || [];
    let ehailingNewList = [];
    const { mkagAgent, riskList = [{}], clientPartner: cpData, ...cngeNote } = this.endtPolicy;
    let thailandDate = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step3?.coverage?.extracover?.thailandDate);

    if(newSubCoverList && newSubCoverList.length > 0){
      if(this.endtType === 'ENDT29'){ 
         newSubCoverList = newSubCoverList.filter(newSubCover => newSubCover.reinstateInd
        );
      }else{
        newSubCoverList = newSubCoverList.filter(newSubCover =>
          !htgeSubCoverList.some(subCover => subCover.subCoverCode === newSubCover.subCoverCode)
        );

        let hasThailandDate = newSubCoverList?.some(subCover => subCover.subCoverCode === '101');
        if(hasThailandDate && this.endtType === 'ENDT17'){
          newSubCoverList = newSubCoverList.map(obj => {
            if (obj.subCoverCode === '101') {
              return {
                ...obj,
                effectiveDate: thailandDate.currentThaiStartDate,
                expiryDate: thailandDate.currentThaiEndDate
              }
            }
    
            return obj;
          })
        }
        
      }
    }

    if (cngeRiskDrvrDtoList && cngeRiskDrvrDtoList.length > 0 && ehailingDriverList && ehailingDriverList.length > 0) {
      ehailingNewList = this.setupEHailing(ehailingDriverList);
      cngeRiskDrvrDtoList = cngeRiskDrvrDtoList.concat(ehailingNewList);
    }

    const payload = {
      cngeNoteDto: {
        productType: this.endtPolicy.productType,
        policyNo: this.endtPolicy.policyNo,
        cnoteType: this.endtType,
        productCode: this.endtPolicy.productCode,
        effectiveDate: this.endtPolicy.effectiveDate,
        expiryDate: this.endtPolicy.expiryDate,
        cnoteDate: this.endtPolicy.cnoteDate,
        proposalDate: this.endtPolicy.proposalDate ? this.endtPolicy.proposalDate : '',
        endtEffectiveDate: new Date(this.issuanceInfo.issuance.endtEffectiveDate).toISOString().split('T')[0],
        endtExpiryDate: new Date(this.issuanceInfo.issuance.endtExpiryDate).toISOString().split('T')[0],
        sumInsured: this.endtPolicy.sumInsured,
        premiumDue: this.endtPolicy.premiumDue || this.endtPolicy.riskList[0].coverList[0].premiumDue,
        mkagAgent: {
          agentCode: this.agentData.agentCode
        },
        riskList: [
          {
            ...this.endtPolicy.riskList[0],
            vehicleCapacity: typeof this.endtPolicy.riskList[0]?.vehicleCapacity === 'string' &&
              this.endtPolicy.riskList[0]?.vehicleCapacity.includes(',')
              ? this.endtPolicy.riskList[0].vehicleCapacity.replace(/,/g, '')
              : this.endtPolicy.riskList[0]?.vehicleCapacity,
            coverList: [{
              ...this.endtPolicy.riskList[0].coverList[0],
              subCoverList: newSubCoverList
            }],
            cngeRiskDrvrDtoList: ehailingDriverList? cngeRiskDrvrDtoList : this.endtPolicy.riskList[0].cngeRiskDrvrDtoList
          }
        ]
      },
      htgePolDto: {
        productCode: this.endtHtgePol?.productCode,
        effectiveDate: this.endtHtgePol?.effectiveDate,
        sumInsured: this.endtHtgePol?.sumInsured,
        mkagAgent: {
          agentCode: this.endtHtgePol?.mkagAgent?.agentCode
        }
      }
    };

    this.store.dispatch(new ENQUIRE_ENDT_NARRATION(payload)).subscribe((state) => {
      let endtNarration = state.SatMotorState?.endorsement?.step3?.endtNarration;
      if(endtNarration) {
        this.endtNarration = endtNarration;
      }
    });
  }

  getChecklistLov() {
    let endtCode = "";
    if (this.endtType === 'COE' || this.endtType === 'XP') {
      endtCode = null;
    } else if (this.endtType.startsWith('ENDT')) {
      endtCode = this.endtType.substring(4);
    } else if (this.endtType.startsWith('EC')) {
      endtCode = this.endtType.substring(2);
    }

    this.store.dispatch(new GET_CHECKLIST_LOV(endtCode)).subscribe(state => {
      this.checklistLov = state.SatMotorState.checklistLov;
    });
  }

  updatePaymentList(paymentList) {
    this.paymentList = paymentList;
    this.onChangePaymentSection();
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }

  showCoverageEditBtn() {
    return (this.endtType === 'XP') ? false : true;
  }

  getPaymentData(data) {
    let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);

    if (endtUpdatedData) {
      this.payment = {
        ...data?.payment,
        accountCode: this.agentData.agentCode,
        insuredName: this.cpData.clientName,
        totalPremiumDue: this.premiumInfo.premiumDue,
        receiptNo: data.receiptNo,
        transactionDate: data.cnoteDate,
        eCoverNoteNo: data.cnoteNo,
        vehicleNo: data?.riskList?.[0]?.vehicleNo,
      };

      this.paymentList = [
        ...endtUpdatedData?.paymentList ?? []
      ];

      this.roadTaxPayable = {
        roadTax: endtUpdatedData.roadTax,
        myegFees: endtUpdatedData.myegFees,
        courierFees: endtUpdatedData.courierFees,
        merchantCharges: endtUpdatedData.merchantCharges,
        totalRoadTaxPayable: endtUpdatedData.totalRoadTaxPayable
      };

      this.paymentInformation = {
        totalPayable: endtUpdatedData.totalPayable,
        totalPayableRounded: endtUpdatedData.totalPayableRounded,
        totalPaid: endtUpdatedData.totalPaid,
        balancePayable: endtUpdatedData.balancePayable
      };
    }
  }

  onChangePaymentSection() {
    let issuanceData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step1.issuance);
    let summaryPremium = this.store.selectSnapshot<any>(state => state.SatMotorState?.endtSummaryPremium?.cngeNoteDto);
    let coveragePremium = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step2.endtUpdatedData);
    let cngeNote = summaryPremium ? summaryPremium : coveragePremium;
    if(this.endtSummaryForm.get('roadTaxPayableForm')) {
      let roadTaxPayableForm = this.endtSummaryForm.get('roadTaxPayableForm');
      cngeNote = {
        ...cngeNote,
        ...roadTaxPayableForm.getRawValue(),
        roadTax: this.numberFmt.transform(roadTaxPayableForm.get('roadTax').value),
        myegFees: this.numberFmt.transform(roadTaxPayableForm.get('myegFees').value),
        merchantCharges:this.numberFmt.transform(roadTaxPayableForm.get('merchantCharges').value),
        courierFees: roadTaxPayableForm.get('courierFees').value ? 6.00 : 0.00,
      };
    }

    cngeNote = {
      ...cngeNote,
      paymentList: this.paymentList ? this.paymentList : [],
      riskList: [{
        ...cngeNote.riskList[0],
        coverList: [{
          ...cngeNote.riskList[0].coverList[0],
          coverDto: {
            ...cngeNote.riskList[0].coverList[0].coverDto,
            checkPremCalc: false
          }
        }]
      }],
    };

    cngeNote.cnoteType = issuanceData.issuance.endorsementType;

    // let policyData = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement.step1?.policyData);

    let payload = {
      // ...policyData,
      cngeNoteDto: cngeNote,
      htgePol: this.endtHtgePol,
      operator: this.userInfo.userId
    };

    this.store.dispatch(new ENDT_CALCULATE_PREMIUM_SUMMARY(payload)).subscribe(state => {
      let premiumSummaryResponse = state.SatMotorState.endorsement.step2.endorsementDetails.coveragePremium.data.cngeNoteDto;
      let roadTaxPayableResponse = {
        roadTax: premiumSummaryResponse.roadTax,
        myegFees: premiumSummaryResponse.myegFees,
        courierFees: premiumSummaryResponse.courierFees,
        merchantCharges: premiumSummaryResponse.merchantCharges,
        totalRoadTaxPayable: premiumSummaryResponse.totalRoadTaxPayable
      };
      this.roadTaxPayable = roadTaxPayableResponse;
      this.store.dispatch(new STORE_ROAD_TAX_PAYABLE({isEndorsement: this.isEndorsement, roadTaxPayable: roadTaxPayableResponse}));

      this.paymentInformation = {
        totalPayable: premiumSummaryResponse.totalPayable,
        totalPayableRounded: premiumSummaryResponse.totalPayableRounded,
        totalPaid: premiumSummaryResponse.totalPaid,
        balancePayable: premiumSummaryResponse.balancePayable
      };
      this.cdr.markForCheck();
      this.cdr.detectChanges();
      this.store.dispatch(new STORE_PAYMENT_INFO({isEndorsement: this.isEndorsement, paymentInfo: this.paymentInformation}));
    });
    
  }

  savePayment() {
    let payload = {
      cngeNote: this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData),
      operator: this.userInfo.userId
    }

    this.store.dispatch(new ENDT_SAVE_PAYMENT(payload)).subscribe(() => {
      let response = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.updatePayment ?? null);

      if (response && response.data && response.success) {
        this.router.navigate(['endorsement/complete'], {
           queryParamsHandling: 'preserve',
        });
      } else {
        this.showResponseError(response);
      }
    });
  }

  getORIXInfo(){    
    this.coverageInfo = {
      ...this.coverageInfo,
      vehicleDetails: {
        ...this.coverageInfo.vehicleDetails,
        leasCompCode: this.prevPolicyData.leasCompCode,
        buyerOverwriteInd: this.prevPolicyData.buyerOverwriteInd
      },
    };

    this.store.dispatch(new SEARCH_ORIXCompanyInfo({ agentCode: this.prevPolicyData.mkagAgent.agentCode, 
      loanCompany: this.prevPolicyData.riskList[0].vehicleLoanCompany, loanType: this.prevPolicyData.riskList[0].vehicleLoanType, 
      vehType: this.prevPolicyData.productCode, eInvoiceInd: this.prevPolicyData.einvoiceConsentInd})).subscribe((state) => {        
        if (state.SatMotorState.lov.searchORIXCompany){
          this.lov = {
            ...this.lov,
            searchORIXCompany: state.SatMotorState?.lov?.searchORIXCompany,
          };
        }
      });
  }

  openPopup(popup_type: any, action: string) {
    this.componentDialogRef = this.dialogService.open(SummaryPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { popup_type: popup_type },
    });
    this.componentDialogRef.afterClosed().subscribe(res=>{
      this.updateEinvoiceConsentInd(true);
      if(action == "generateQuotation"){
        this.generate();
      }
      if(action == "sendToJPJ"){
        this.sendToJPJ();
      }
    })
  }

  einvoiceConsentInd(){
    return this.issuanceInfo?.pdpa?.consentDetails?.einvoiceConsentInd;
  }

  isGrossPremiumMoreThan10k() {
    const einvoice10kTransAmount = this.store.selectSnapshot(SatMotorState.einvoice10kTransAmount);
    let grossPremium  = this.premiumInfo.grossPremium - this.premiumInfo.rebateAmt;
    return Math.abs(grossPremium) > einvoice10kTransAmount;
  }

  updateEinvoiceConsentInd(einvoiceConsentInd){
    this.issuanceInfo = {
      ...this.issuanceInfo, 
      pdpa:{
        ...this.issuanceInfo.pdpa,
        consentDetails:{
          ...this.issuanceInfo.pdpa.consentDetails,
          einvoiceConsentInd: einvoiceConsentInd
        }
      }
    }
  }

}